import React, { Fragment, Helmet, useState, useEffect } from "react";
import { Submitclup } from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";

function Index() {
  const initialState = {
    data: null,
    loading: false,
  };

  const [state, setstate] = useState(initialState);
  const submit = data => {
    setstate({ ...state, loading: true });
    Submitclup(data).then(() => {
      setstate({ ...state, loading: false });
    });
  };
  return (
    <CommonFrom
      form={[
        {
          label: "عکس های بنر",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "bannerclup",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
        {
          label: "وکتور امتیاز سفارش",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "imagefordesclup_order",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
        {
          label: "وکتور امتیاز هر کامنت",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "imagefordesclup_comment",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
        {
          label: "وکتور امتیاز تکمیل پروفایل",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "imagefordesclup_profile",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
        {
          label: "وکتور امتیاز دعوت از دوستان",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "imagefordesclup_invate",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
        {
          label: "وکتور امتیاز ثبت نام در اپ",
          size: "col-md-12",
          classNames: "mt-2",
          placeholder: "",
          name: "imagefordesclup_singapp",
          input: "file",
          accept: "image/png, image/jpeg, image/jpg",
        },
      ]}
      loading={state.loading}
      submit={submit}
      header="تنظیمات باشگاه مشتریان"
      btnName="ثبت تغییرات "
    />
  );
}

export default Index;
